import { Component, OnInit, ViewChild } from '@angular/core';
import { ContractType } from '../../../shared/models/contract/contract-type.model';
import { PostPartialCJModel } from '../../../shared/models/partial-cj/post-partial-cj';
import { StartUpConfigUiService } from '../../../shared/service/ui/start-up-config-ui.service';
import { SavePartailDetailsComponent } from '../../components/save-partail-details/save-partail-details.component';
import { SwProcessStateService } from '../../service/ui/sw-process-state.service';
import { AbTestConfigModel } from 'src/app/shared/models/start-up-config/abtest-config-model';
import { ApplicationConstant } from 'src/app/application.constant';

@Component({
  selector: 'sw-process, [swProcess]',
  templateUrl: './sw-process.component.html'
})
export class SwProcessComponent implements OnInit {
  private abTestConfig: AbTestConfigModel = ApplicationConstant.abTestConfig;
  public returnCode: string | null;
  public isPartailsCJ = false;

  @ViewChild('partialInfoSaveModel') partialInfoSaveModel: SavePartailDetailsComponent | undefined;

  constructor(
    private swProcessStateService: SwProcessStateService,
    private startUpConfigUiService: StartUpConfigUiService
  ) {}

  public ngOnInit() {
    this.swProcessStateService.initSwProcess();
    this.swProcessStateService.returnCode$.subscribe(rc => this.returnCode = rc);
    this.startUpConfigUiService.sessionInfo$.subscribe((res) => {
      this.isPartailsCJ = res.isCallCenter;
    });
  }

  public showPartialCJSaveInfoModal() {
    this.partialInfoSaveModel?.show();
  }

  public savePartailCJContractDetails(partialDetails: any) {
    const request: PostPartialCJModel = {
      operatorId: partialDetails.operator,
      UserTelephoneNumber: partialDetails.telephone,
      partialCJRiskData: new ContractType()
    };

    this.swProcessStateService.savePartailCJContractDetails(request).subscribe((res) => {
      if (this.partialInfoSaveModel && res === true) {
        this.partialInfoSaveModel.isDataSaved = true;
      }
    });
  }

  public getQuotes() {
    this.swProcessStateService.submitSwInput(this.abTestConfig);
  }
}
